import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ManageLobbyContainerService {
    readonly recommendedGamesSubcategoryID = 'LMC_RECOMMENDED GAMES FOR YOU';
    readonly initialRecommendedGamesContainerPosition = -2;
    recommendedGamesContainerPosition = signal<number>(this.initialRecommendedGamesContainerPosition);

    getAdjustedRecommendedGamesSubcategory(subcategories: any): any {
        const currentIndex = this.getRecommendedGamesSubcategoryIndex(subcategories);
        const currentPosition = this.recommendedGamesContainerPosition();
        if (currentIndex === -1 || currentPosition === this.initialRecommendedGamesContainerPosition) {
            return subcategories;
        }
        return this.adjustRecommendedGamesSubcategoryPosition(subcategories, currentIndex, currentPosition);
    }

    private getRecommendedGamesSubcategoryIndex(subcategories: any): number {
        return subcategories.findIndex((subcategory: any) => {
            if (subcategory?.categoryInfo) {
                return subcategory.categoryInfo?.subcategoryid === this.recommendedGamesSubcategoryID;
            }
            return subcategory?.subcategoryid === this.recommendedGamesSubcategoryID;
        });
    }

    private adjustRecommendedGamesSubcategoryPosition(
        subcategories: any,
        currentRecommendedGamesContainerIndex: number,
        expectedRecommendedGamesContainerPosition: number,
    ): any[] {
        if (expectedRecommendedGamesContainerPosition === 0 || expectedRecommendedGamesContainerPosition >= subcategories.length) {
            return subcategories;
        }
        const updatedSubcategories = [
            ...subcategories.slice(0, currentRecommendedGamesContainerIndex),
            ...subcategories.slice(currentRecommendedGamesContainerIndex + 1),
        ];
        if (expectedRecommendedGamesContainerPosition !== -1) {
            updatedSubcategories.splice(expectedRecommendedGamesContainerPosition, 0, subcategories[currentRecommendedGamesContainerIndex]);
        }
        return updatedSubcategories;
    }
}
